import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogonew = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 85 84",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2152_2554)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M32.1391 59.7064C32.1146 54.963 32.086 50.2237 32.0615 45.4844V45.6494C32.086 50.3351 32.1146 55.0249 32.1391 59.7105",
				className: "fill-current"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.021 59.0553L31.4287 59.6534H32.0986C32.0741 54.976 32.0455 50.2985 32.021 45.6211V59.0553Z",
				className: "fill-current"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M46.4643 84C20.8446 84 0 62.9557 0 37.0854C0 22.4797 6.56014 8.96303 17.9975 0L22.5357 5.90248C12.916 13.4425 7.39752 24.8061 7.39752 37.0854C7.39752 58.8351 24.9212 76.5343 46.4643 76.5343C57.003 76.5343 66.884 72.36 74.2856 64.7788L79.555 70.0254C70.7523 79.0421 59.0045 84.0041 46.4684 84.0041",
				className: "fill-current"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M58.8856 26.6526H51.386V36.0404H32.2406L31.9915 35.7476C31.9588 30.0472 31.9261 24.3427 31.8975 18.6424C29.4466 15.5818 26.9958 12.5254 24.5449 9.46484V59.6421H31.4523L32.0446 59.044V43.2422H51.386C51.3819 48.7075 51.3778 54.1727 51.3696 59.6421C51.5738 59.6421 51.774 59.6421 51.9782 59.6462H59.0939V26.6526H58.8856Z",
				className: "fill-current"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M75.2378 45.1234C83.8812 43.6797 86.908 33.9124 83.8281 26.8302C83.3461 25.7166 82.2555 23.8109 80.352 22.1817C77.4028 19.6573 74.184 19.1706 72.9218 19.0469H59.1152V26.6199C63.584 26.6199 68.0527 26.6199 72.5215 26.6199C75.7321 26.7519 78.3014 29.3752 78.4117 32.5141C78.5261 35.8015 75.9077 38.6888 72.5419 38.8455C69.5763 38.8909 66.6108 38.9363 63.6452 38.9817H63.4614V45.1646H63.4655C66.9294 49.9947 70.3933 54.8247 73.8572 59.6548H81.2179C79.8373 57.4522 78.3463 55.1877 76.7288 52.8737C74.8089 50.1225 72.8891 47.5528 71.0019 45.1646C72.4153 45.1523 73.8286 45.1399 75.2419 45.1316L75.2378 45.1234Z",
				className: "fill-current"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2152_2554",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 85,
			height: 84,
			className: "fill-current"
		})
	}) })]
});
export default SvgLogonew;
